import React,{useState,useEffect} from 'react';
import Loading from "./Loading";
//import Inc from './Include';
import './Result.scss';

let play = null;

function Result ({ajax,resultKey,close}){
	const [isLoading,setIsLoading] = useState(true);
	useEffect( ()=>{
		ajax("play/get",{result_key:resultKey},(res)=>{
			console.log(res);
			if( res.ok ){
				play = res.play;
				setIsLoading(false);
			} else {
				close();
			}
		});
	},[ajax,close,resultKey])

	if( isLoading ){
		return (
			<div id="result">
				<Loading/>
			</div>
		)
	}

	let text = play.turn+"fish! ひとりになると死んじゃう"+play.name+"の冒険～Farrow #レトロインク";
	const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Ffarrow%2F"+resultKey+"&text="+encodeURIComponent(text);

	return (
		<div id="result">
			<div className="fish">
				<i className="fas fa-fish"></i>
				<div className="title">Farrow</div>
				<div className="circle">
					<p className="score"><span>{play.turn}</span> fish</p>
					<p className="copy">～{play.name}は死んじゃった～</p>
				</div>
			</div>
			<div className="tweet">
				<a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer"><span className="fab fa-twitter"></span> 結果をツイート</a>
			</div>
			<div className="choices">
				<button
					onClick={close}
				>最初から始める</button>
			</div>
		</div>
    );
}

export default Result;
